import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import CancelRules from "../components/layouts/checkout/CancelRules";
import CheckoutStepbar from "../components/layouts/checkout/CheckoutStepbar";
import RequestForm from "../components/layouts/checkout/RequestForm";
import ResidenceDetailBos from "../components/layouts/checkout/ResidenceDetailBos";
import TimetoResponde from "../components/layouts/checkout/TimetoResponde";
import useFetch from "../hooks/useAxios";
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { API_URL } from "../constants";
import Cookies from "js-cookie";

const Checkout = () => {
  const [phase, setPhase] = useState(1);
  const [inforesidencedetail, setinforesidencedetail] = useState() 
  const [reserveinfodetail , setReserveInfodetail] = useState() 
  const {code,slug,id}=useParams()
  const [isReserveSuccess, setIsReserveSuccess] = useState()

  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/residences/${code}/${slug}`,
    noHeader: true,
    trigger: true,
    argFunc:(res)=>setinforesidencedetail(res.data),
  });
  const navigate = useNavigate()

  const apiReserve = useFetch({
    method: "get",
    url: `api/guest/reserve/${code}/${id}`,
    noHeader: false,
    trigger: true,
    argFunc:(res)=>{setReserveInfodetail(res.data.reserve);setIsReserveSuccess(res.data.reserve.status)},
    errMessage:(err)=>{toast.error("این اقامتگاه برای شما رزرو نشده"); navigate(-1)}
   
  });

  const steps = [
    {
      PhaseNumber: 1,
      phaseName: "ثبت درخواست"
    },
    {
      PhaseNumber: 2,
      phaseName: "تایید میزبان"
    },
    {
      PhaseNumber: 3,
      phaseName: "پرداخت نهایی"
    }
  ];

  window.Pusher = Pusher;
  // window.Pusher.logToConsole = true;

  window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'b0186db0f714b3c62cad',
      cluster: 'mt1',
      encrypted:false,
      authEndpoint: API_URL + '/api/broadcasting/auth',
      auth: {
        headers: {
            Authorization: 'Bearer ' + Cookies.get("token")
        },
      }
  });
  
  useEffect(() => {
    if(isReserveSuccess === false){
      navigate("/user/mytrips")
    }
  }, [isReserveSuccess])


  window.Echo.private('reserves.' + id)
    .listen('.reserve.status', (e) => {
      console.log("pusher response",e)
      if (e.reserve.status === 'accepted') {
        setIsReserveSuccess("تایید شده")
        console.log("pusher response",e.reserve.status)
      }

      if (e.reserve.status === 'failed') {
        setIsReserveSuccess(false)
      }
  });
 console.log("status pusher: ",isReserveSuccess)
  return (
    <div className="Checkout">
      <div className="Checkout--bg-header" />
      <CheckoutStepbar PhaseNum={1} PhaseList={steps} />
    { isReserveSuccess === undefined ||  isReserveSuccess === null ||  isReserveSuccess === "در حال پردازش" 
 ?  <TimetoResponde /> : isReserveSuccess === "تایید شده" ?
  <div  className="center my-[40px]">
   <h3 className="text-[32px]">
   رزرو شما توسط ادمین تایید شد .لطفا صورتحساب خود را پرداخت کنید .
   </h3>
    </div>:null}

     {inforesidencedetail && reserveinfodetail && <div className="container">
        <div className="Checkout--grid ">
          <RequestForm isReserveSuccess={isReserveSuccess} inforesidencedetail={inforesidencedetail} reserveinfodetail={reserveinfodetail} />
          <ResidenceDetailBos isReserveSuccess={isReserveSuccess} inforesidencedetail={inforesidencedetail} reserveinfodetail={reserveinfodetail} />
        </div>
        <CancelRules inforesidencedetail={inforesidencedetail} />
      </div>}
    </div>
  );
};

export default Checkout;
